import { createServerFn } from "@tanstack/react-start";
import { parseEcbRates, type CurrencyRates } from "../../src/lib/currency-rates";

// The ECB publishes once each working day, around 16:00 CET; six hours at the edge is plenty.
const ecbDaily = "https://www.ecb.europa.eu/stats/eurofxref/eurofxref-daily.xml";

/** Today's reference rates for the header's currency picker, or null while they can't be read. */
export const loadCurrencyRates = createServerFn({ method: "GET" }).handler(
  async (): Promise<CurrencyRates | null> => {
    try {
      const response = await fetch(ecbDaily, {
        cf: { cacheTtl: 6 * 60 * 60, cacheEverything: true },
        signal: AbortSignal.timeout(5_000),
      });
      return response.ok ? parseEcbRates(await response.text()) : null;
    } catch {
      return null;
    }
  },
);
